<template>
  <div>
    <contaCorrentComponent :subjectPermission="subjectPermission" />
  </div>
</template>
<script>
import contaCorrentComponent from './conta.corrente.list.vue';
export default {
  name: 'conta-corrente',
  components: { contaCorrentComponent },
  data() {
    return {
      subjectPermission: 'Conta Corrente',
    };
  },
};
</script>
<style></style>
